import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Header from 'components/header/Header';
import Footer from 'components/footer/Footer';
import Content from 'components/Content';
import RequiresAuth from 'components/auth/RequiresAuth';
import Status from 'components/common/Status';
import BundleTypeBar from 'components/common/BundleTypeBar';
import PurchasedItem from 'components/purchases/PurchasedItem';
import * as Const from 'util/constants';
import './MyPurchases.scss';
import '@fortawesome/fontawesome-free/css/all.min.css';

import { asyncFetchMyPurchases, selectBundleType } from 'actions/user';
import { preloadBundle } from 'actions/bundles';
import { preloadTemplate } from 'actions/templates';
import { orderComplete } from 'actions/order';

const fbq = window.fbq;
export class MyPurchases extends Component {
  state = {
    type: ''
  };
  componentDidMount() {
    this.load();
    document.title = 'Doodly: My Purchases';
  }

  componentDidUpdate() {
    const { type } = this.props.match.params;
    const { currentBundleType, isFetching } = this.props;
    if (!isFetching && type !== currentBundleType) this.load();
  }

  load() {
    const { type } = this.props.match.params;
    const { setBundleType, fetchMyPurchases, purchasedProductId, completePurchase } = this.props;

    setBundleType(type);
    fetchMyPurchases(type);

    if (purchasedProductId === '41439') {
      // facebook ultimate
      fbq('track', 'PageView');
      fbq('track', 'PurchaseDoodlyUltimate');
      fbq('track', 'Purchase', {
        value: 497.0,
        currency: 'USD',
        product: 'PurchaseDoodlyUltimate'
      });

      completePurchase();
    }
  }

  render() {
    let { type } = this.props.match.params;
    const { isFetching, bundles, loadBundle, loadTemplate } = this.props;
    let title, desc;
    switch (type) {
      case Const.TYPE_AUDIO_BUNDLES:
        title = 'My Purchased Audio Bundles';
        desc = (
          <p className="mb-5">
            Each of your purchased bundles will appear directly inside of your Doodly software. It is located under the
            "Marketplace" tab.
          </p>
        );
        break;
      case Const.TYPE_TEMPLATES:
        title = 'My Purchased Templates';
        desc = (
          <p className="mb-5">
            Each of your purchased templates will appear directly inside of your Doodly software. It is located under
            the "Templates" tab. <br />
            If you own the <a href="https://www.doodly.com/rainbow/">Doodly Rainbow addon</a>, you can easily switch
            back and forth between the two.
          </p>
        );
        break;
      default:
        title = 'My Purchased Image Bundles';
        desc = (
          <p className="mb-5">
            Each of your purchased bundles will appear directly inside of your Doodly software. It is located under the
            "Marketplace" tab. <br />
            All images are complete with draw paths for realistic drawing animation. If you own the{' '}
            <a href="https://www.doodly.com/rainbow/">Doodly Rainbow addon</a>, you will also be able to use the color
            versions of each image.
          </p>
        );
        type = Const.TYPE_IMAGE_BUNDLES;
        break;
    }
    return (
      <div className="my-purchases d-flex flex-column">
        <RequiresAuth />
        <Header className={type} />
        <Content className={type}>
          <div className="breadcrumbs">
            <Link to="/">Home</Link>
            <span className="sep">&gt;</span>
            My Purchases
          </div>
          <div className="sheet">
            <h2 className="text-center mb-3">{title}</h2>
            <Status />
            <div className="d-flex justify-content-center mb-4">
              <BundleTypeBar className={type} isPurchased={true} />
            </div>
            {desc}
            <div className="purchase-list d-flex flex-wrap">
              {isFetching ? (
                <div className="loading">
                  <i className="fas fa-spinner fa-spin" />
                </div>
              ) : bundles && bundles.length ? (
                bundles.map((bundle, i) => (
                  <PurchasedItem
                    className="col-md-6 col-lg-3"
                    type={type}
                    item={bundle}
                    onSelect={type === Const.TYPE_TEMPLATES ? loadTemplate : loadBundle}
                    key={i}
                  />
                ))
              ) : (
                <p className="ml-3">No bundles purchased yet.</p>
              )}
            </div>
          </div>
        </Content>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { marketBundles, isFetching, bundleType } = state.user;
  const { purchasedProductId } = state.order;
  return {
    bundles: marketBundles,
    isFetching,
    currentBundleType: bundleType,
    purchasedProductId
  };
};

const mapDispatchToProps = dispatch => ({
  fetchMyPurchases: type => dispatch(asyncFetchMyPurchases(type)),
  setBundleType: type => dispatch(selectBundleType(type, true)),
  loadBundle: bundle => dispatch(preloadBundle(bundle)),
  loadTemplate: template => dispatch(preloadTemplate(template)),
  completePurchase: bundle => dispatch(orderComplete(bundle))
});

export default connect(mapStateToProps, mapDispatchToProps)(MyPurchases);
